module.exports = __webpack_public_path__ + "static/media/Avatar.a96e68ed.jpeg";